import React, {FC, useState} from 'react';
import messages from '../messages';
import {InvoiceFilters} from './types';
import AppBarActions from 'components/VerticalLayout/app-bar-actions';
import Button from 'components/button';
import {FilterMap} from 'features/table/slice/types';
import {useLazyGetOverpaymentsExportQuery} from 'pages/accounting/store/endpoints/export-overpayments';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import toast from 'store/ui/actions/toast';
import {useLazyGetPaymentsExportQuery} from 'pages/accounting/store/endpoints/export-payments';

interface Props {
  filters: FilterMap<InvoiceFilters>;
}

const Actions: FC<Props> = props => {
  const {filters} = props;

  const {t} = useTranslation();

  const dispatch = useDispatch();

  const [onExport, {isFetching: isLoadingOverpayements}] =
    useLazyGetPaymentsExportQuery();

  const onSubmit = async (filters: any) => {
    const result = await onExport(filters);
    if ('data' in result) {
      dispatch(toast('success', result?.data?.message));
    }
  };

  return (
    <div>
      <AppBarActions>
        {/* Action */}
        <Button
          color="light"
          isLoading={isLoadingOverpayements}
          onClick={() => onSubmit(filters)}
        >
          {t(...messages.export())}
        </Button>
      </AppBarActions>
    </div>
  );
};

export default Actions;
